<input type="text" class="form-control fn-input" [(ngModel)]="value" fnTelInput fnNumberDirective [disabled]="isDisabled" [class]="customClass" [name]="name" [placeholder]="placeholder" [fnTelInputOptions]="fnTelInputOptions" (fnTelOutput)="getTelNumber.emit($event)" (hasError)="hasError($event)" (intlTelInputObject)="telInputObject.emit($event)"
    (countryChange)="changeCountry.emit($event) " />

@if (parentForm && !(isValid)) {
<fn-input-error [position]="'bottom'" [submitted]="parentForm.submitted" [control]="parentForm.form.controls[name]" [tabIndex]="tabIndex">
</fn-input-error>
}
